import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-concrete-700 shrink-0 text-base" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "min-w-0 flex-1 break-words" }
const _hoisted_5 = {
  key: 0,
  class: "shrink-0 tabular-nums text-concrete-700"
}

interface Props {
	label: string;
	checked: boolean;
	count?: number | null;
	disabled?: boolean;
	loading?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FilterLocationOption',
  props: {
    label: {},
    checked: { type: Boolean },
    count: { default: null },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  },
  emits: ["toggle"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass([
			'inline-flex w-full min-w-0 items-center gap-2 py-2 text-left',
			'font-primary text-sm text-black',
			'focus:outline-none focus:ring-4 focus:ring-celestial-500',
			__props.disabled || __props.loading ? 'pointer-events-none opacity-40' : 'hover:opacity-80',
		]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('toggle')))
  }, [
    _createElementVNode("span", _hoisted_1, [
      (__props.checked)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("i", { class: "fa-solid fa-square-check" }, null, -1)
          ]))]))
        : (_openBlock(), _createElementBlock("span", _hoisted_3, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("i", { class: "fa-regular fa-square" }, null, -1)
          ]))]))
    ]),
    _createElementVNode("span", _hoisted_4, _toDisplayString(__props.label), 1),
    (__props.count !== null)
      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.count), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})